import PageHero from '@/components/feature/PageHero';
import { demoHero } from '@/mocks/demo';

export default function Hero() {
  return (
    <PageHero
      eyebrow={demoHero.eyebrow}
      title={demoHero.title}
      titleHighlight={demoHero.titleHighlight}
      subtitle={demoHero.subtitle}
      desc={demoHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Digital%20twin%20dashboard%20visualization%20of%20a%20rural%20digital%20commerce%20operating%20system%20with%20holographic%20panels%2C%20glowing%20green%20and%20gold%20data%20nodes%20over%20deep%20navy%20ink%20background%2C%20futuristic%20command%20center%20interface%2C%20flowing%20AI%20data%20streams%20connecting%20county%20network%20nodes%2C%20cinematic%20minimal%20composition&width=1800&height=1200&seq=demo-hero-01&orientation=landscape"
      imageAlt="九畴云市数字经济操作系统数字孪生演示"
      imageTitle="九畴云市 项目演示中心"
    />
  );
}